.image {
    display: block;

    img {
        aspect-ratio: var(--image-ar);
        object-fit: cover;
    }
}

.guideImage {
    aspect-ratio: 3/4;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: clip;
    container-type: inline-size;

    :global(.imageDataWrapper) {
        aspect-ratio: 3/2;
        width: 100%;
        display: flex;
        justify-content: center;

        & > svg {
            height: 100%;
            color: var(--color-contrast);
        }
    }
}

.guideTitle {
    composes: fontHB56 from "../../styles/typography.module.scss";
    font-size: 22cqw;
    margin: var(--spacer-12);
    padding-top: var(--spacer-16);
    border-top: 1px solid var(--color-contrast);
    text-wrap: balance;
    max-height: 55cqw; // force tiles to remain in 3/4, text will overflow
}
